import {
  StoreCss,
  StoreGrid,
  StoreItem,
  Title,
  WhyChooseUs,
  BenefitsGrid,
  BenefitItem,
} from "./styles";

// Dados dos itens da loja
const storeItems = [
  {
    type: "image",
    src: "images/store-front.jpg",
    title: "Venha nos visitar",
  },
  {
    type: "video",
    src: "/videos/phone-repair.mp4",
    title: "Manutenção Profissional",
  },
  {
    type: "image",
    src: "/images/repair-equipment.jpg",
    title: "Equipamentos",
  },
];

// Dados dos benefícios
const benefits = [
  {
    title: "Técnicos Especializados",
    description:
      "Equipe altamente qualificada e certificada pelas principais marcas do mercado.",
  },
  {
    title: "Agilidade no Reparo",
    description:
      "Consertos rápidos e eficientes, para você não ficar muito tempo sem seu aparelho.",
  },
  {
    title: "Garantia de Serviço",
    description:
      "Todos os reparos possuem garantia, assegurando a qualidade do nosso trabalho.",
  },
  {
    title: "Segurança Total",
    description:
      "Seus dados são protegidos e sua privacidade é nossa prioridade.",
  },
  {
    title: "Atendimento Personalizado",
    description:
      "Transparência e atenção especial para cada cliente e necessidade.",
  },
  {
    title: "Peças Originais",
    description:
      "Utilizamos apenas peças originais e de alta qualidade nos reparos.",
  },
];

const Store = () => (
  <StoreCss id="store">
    <div className="container">
      {/* Título da seção */}
      <Title>
        <h2>Nossa Loja</h2>
        <p>Conheça nosso espaço e estrutura</p>
      </Title>

      {/* Grid de itens */}
      <StoreGrid>
        {storeItems.map(({ type, src, title }, index) => (
          <StoreItem key={index}>
            {/* Renderização condicional de imagem ou vídeo */}
            {type === "image" ? (
              <img src={src} alt={title} loading="lazy" />
            ) : (
              <video autoPlay loop muted playsInline preload="metadata">
                <source src={src} type="video/mp4" />
                Seu navegador não suporta vídeos.
              </video>
            )}
            <h3>{title}</h3>
          </StoreItem>
        ))}
      </StoreGrid>

      {/* Seção Por que escolher a EngenhosoCell */}
      <WhyChooseUs>
        <BenefitsGrid>
          {benefits.map((benefit, index) => (
            <BenefitItem key={index}>
              <h3>{benefit.title}</h3>
              <p>{benefit.description}</p>
            </BenefitItem>
          ))}
        </BenefitsGrid>
      </WhyChooseUs>
    </div>
  </StoreCss>
);

export default Store;
